<template>
  <div>
    <table v-show="leagues.length > 0" class="table table-bordered table-hover">
      <thead class="thead-dark">
        <tr>
          <th>#</th>
          <th>Min player level</th>
          <th>Max player level</th>
          <th>Max participants</th>
          <th>Max place</th>
          <th>Target score</th>
          <th>Score threshold</th>
          <th>Score emul time step</th>
          <th>Score emul time total</th>
          <th>Rewards</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="league in leagues" :key="league.id">
          <td>{{ league.id }}</td>
          <td>{{ league.min_player_level }}</td>
          <td>{{ league.max_player_level }}</td>
          <td>{{ league.max_participants }}</td>
          <td>{{ league.max_place }}</td>
          <td>{{ league.target_score }}</td>
          <td>{{ league.score_threshold }}</td>
          <td>{{ league.score_emul_time_step | getDurationStr }}</td>
          <td>{{ league.score_emul_time_total  | getDurationStr }}</td>
          <td>
            <b-button v-b-modal.rewards-modal size="sm" @click="showRewards(derbyId, league.id)">show</b-button>
          </td>
        </tr>
      </tbody>
    </table>

    <loading-indicator v-if="isLoading"></loading-indicator>

    <b-modal id="rewards-modal" title="Rewards" ok-only ok-title="Close" size="xl">
      <table class="table">
        <thead class="thead-dark">
          <tr>
            <th>Place</th>
            <th>Item</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(reward, index) in rewards" :key="index">
            <td>{{ reward.place }}</td>
            <td>{{ reward.proto_id | getProtoAlias }}</td>
            <td>{{ reward.amount }}</td>
          </tr>
        </tbody>
      </table>
    </b-modal>
  </div>
</template>

<script>
import LoadingIndicator from '../LoadingIndicator.vue';

import {HTTP} from '../../http-common.js';
import notifier from '../../notifier.js';

export default {
  name: 'DerbyLeagueList',
  components: {
    LoadingIndicator,
  },

  props: {
    derbyId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
      leagues: [],
      rewards: [],
    };
  },

  created() {
    this.loadLeagues(this.derbyId);
  },
  
  methods: {
    loadLeagues(derbyId) {
      notifier.deleteSenderNotifications(this);

      this.isLoading = true;

      HTTP.get(`/derbies/${derbyId}/leagues`)
      .then(response => {
        const data = response.data.data;
        if(data === null) {
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        const leagues = data.leagues || [];
        leagues.sort((a, b) => a.min_player_level - b.min_player_level);

        this.leagues = leagues;
      })
      .catch(e => {
        notifier.showError(e, {sender: this});
      })
      .finally(() => {
        this.isLoading = false;
      });
    },

    showRewards(derbyId, leagueId) {
      notifier.deleteSenderNotifications(this);

      HTTP.get(`/derbies/${derbyId}/leagues/${leagueId}/rewards`)
      .then(response => {
        const data = response.data.data;
        if(data === null) {
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        const rewards = data.rewards || [];
        rewards.sort((a, b) => a.place - b.place);

        this.rewards = rewards;
      })
      .catch(e => {
        notifier.showError(e, {sender: this});
      })
    },
  },
}
</script>
